// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-highcharts-tooltip-container_type_timeline {
  width: 100%;
  height: 100%;
}
.chartkit-highcharts-tooltip-container._tooltip-with-scroll ._tooltip-header td:last-child {
  padding-right: calc(18px + var(--g-scrollbar-width, 15px));
}
.chartkit-highcharts-tooltip-container._tooltip-with-scroll ._tooltip-footer td:last-child {
  padding-right: calc(18px + var(--g-scrollbar-width, 15px));
}
.chartkit-highcharts-tooltip-container._tooltip-with-scroll-in-safari ._tooltip-row td:last-child {
  padding-right: calc(18px + var(--g-scrollbar-width, 15px));
}
.chartkit-highcharts-tooltip-container._tooltip-with-scroll-in-safari ._tooltip-rows__summ-tr td:last-child {
  padding-right: calc(18px + var(--g-scrollbar-width, 15px));
}

._tooltip {
  border-radius: 5px;
  background: var(--highcharts-tooltip-bg);
  color: var(--highcharts-tooltip-text);
  font-size: 12px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.15);
}
._tooltip_split-tooltip {
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding-bottom: 12px;
}
._tooltip_split-tooltip table {
  table-layout: fixed;
}
._tooltip_split-tooltip ._tooltip-rows__table tbody {
  display: table-row-group;
}
@supports (padding: max(0px)) {
  ._tooltip_split-tooltip {
    padding-bottom: max(12px, env(safe-area-inset-bottom));
  }
}
._tooltip table {
  width: 100%;
}
._tooltip table td {
  box-sizing: border-box;
}
._tooltip table td:last-child {
  text-align: right;
}
._tooltip-fake-row {
  height: 5px;
}
._tooltip-fake-row-heightless {
  height: 0;
}
._tooltip-fake-row-heightless td {
  padding: 0;
}
._tooltip-fake-row td:first-child {
  width: 28px;
}
._tooltip-row {
  width: 100%;
}
._tooltip-row td:first-child {
  padding-left: 14px;
}
._tooltip-row td:last-child {
  padding-right: 18px;
}
._tooltip-row td {
  padding: 2px 4px;
}
._tooltip-row td._tooltip-rows__value-td, ._tooltip-row td._tooltip-rows__diff-td {
  padding-bottom: 1px;
}
._tooltip-selected-row {
  font-weight: 600;
}
._tooltip-comment-row td:last-child {
  padding-right: 18px;
}
._tooltip-right__td {
  padding-right: 14px;
}
._tooltip-right__td_with-split-tooltip {
  border: none;
}
._tooltip-date {
  padding: 10px 14px 4px;
  max-width: 450px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: bold;
}
._tooltip-date-dayofweek {
  display: inline-block;
}
._tooltip-date-dayofweek_weekend {
  color: #ff0000;
}
._tooltip-rows__table {
  border-spacing: 0;
  width: 10px;
}
._tooltip-rows__table-footer {
  display: table;
  width: 100%;
}
._tooltip-rows__table thead {
  display: table;
  width: 100%;
}
._tooltip-rows__table thead._tooltip-header tr:not(._tooltip-fake-row):first-child td {
  padding-top: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--highcharts-grid-line);
}
._tooltip-rows__table tbody {
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
}
._tooltip-rows__table tbody._tooltip-footer {
  width: 100%;
  display: table;
}
._tooltip-rows__table tbody._tooltip-list {
  overflow-x: hidden;
}
._tooltip-rows__table tbody._tooltip-list ._tooltip-row-dark-bg {
  background-color: var(--highcharts-tooltip-alternate-bg);
}
._tooltip-rows__table tbody ._hidden-rows-sum._hidden-rows-sum-dark-bg {
  background-color: var(--highcharts-tooltip-alternate-bg);
}
._tooltip-rows__table tbody ._hidden-rows-sum td {
  padding-top: 2px;
  padding-bottom: 2px;
}
._tooltip-rows__table tbody td._hidden-rows-number {
  text-align: left;
  padding-right: 20px;
}
._tooltip-rows__table tbody td._hidden-rows-value {
  font-family: "Consolas", "Menlo", "Ubuntu Mono", monospace;
  word-spacing: -3px;
}
._tooltip-rows__bubble-div {
  display: inline-block;
  width: 12px;
  height: 6px;
  margin-left: 1px;
  margin-bottom: 1px;
  border-radius: 1px;
}
._tooltip-rows__shape-div {
  width: 38px;
  display: flex;
  align-items: center;
  height: 100%;
}
._tooltip-rows__shape-td {
  height: 20px;
}
._tooltip-rows__percent-td {
  font-family: "Consolas", "Menlo", "Ubuntu Mono", monospace;
  word-spacing: -3px;
  padding-left: 12px;
  white-space: nowrap;
}
._tooltip-rows__diff-td {
  font-family: "Consolas", "Menlo", "Ubuntu Mono", monospace;
  word-spacing: -3px;
  padding-left: 3px;
  padding-right: 3px;
  white-space: nowrap;
}
._tooltip-rows__comment-left-td {
  position: relative;
}
._tooltip-rows__comment-left-div {
  left: 2px;
  position: absolute;
  top: -7px;
  bottom: 6px;
  width: 10px;
}
._tooltip-rows__comment-div {
  position: relative;
  padding-left: 14px;
  text-align: left;
  font-size: 10px;
  width: auto;
  white-space: normal;
  letter-spacing: 0.2px;
  font-weight: normal;
  line-height: 1.3;
  color: #aaaaaa;
}
._tooltip-rows__bubble-td {
  width: 28px;
}
._tooltip-rows__value-td {
  font-family: "Consolas", "Menlo", "Ubuntu Mono", monospace;
  word-spacing: -3px;
  white-space: nowrap;
  padding-left: 12px;
}
._tooltip-rows__value-td_selected {
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
._tooltip-rows__name-td {
  text-align: left;
  white-space: nowrap;
  padding-left: 10px;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
}
._tooltip-rows__name-td_selected {
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
._tooltip-rows__summ-td {
  padding: 6px 0 6px 3px;
  color: var(--highcharts-tooltip-text-complementary);
  font-size: 12px;
  border-top: 1px solid var(--highcharts-grid-line);
}
._tooltip-rows__summ-td-value {
  font-family: "Consolas", "Menlo", "Ubuntu Mono", monospace;
  word-spacing: -3px;
}
._tooltip-rows__summ-td:first-child {
  padding-left: 15px;
  text-align: left;
}
._tooltip-rows__summ-td:last-child {
  padding-right: 18px;
  text-align: right;
}
._tooltip-left__td {
  vertical-align: top;
}
._tooltip-right__td {
  vertical-align: top;
  opacity: 0.9;
  border-left: 1px solid var(--highcharts-grid-line);
  white-space: normal;
  font-size: 8pt;
  position: relative;
  min-width: 120px;
  max-width: 150px;
  padding-left: 10px;
}
._tooltip-right__holiday-div {
  padding-bottom: 5px;
  display: flex;
  align-items: center;
  text-align: left;
}
._tooltip-right__holiday-emoji {
  font-size: 20px;
}
._tooltip-right__holiday-region {
  color: #ffffff;
  letter-spacing: 1px;
  display: inline-block;
  padding-left: 5px;
}
._tooltip-right__traf-div {
  text-align: left;
  border-top: 3px solid;
  padding-top: 3px;
  font-size: 10px;
  line-height: 1.3;
  white-space: pre-line;
  padding-bottom: 10px;
  margin-top: 9px;
  word-break: break-word;
}
._tooltip-right__traf-div_for-split-tooltip {
  color: var(--g-color-text-secondary);
  padding-left: 8px;
  border-top: none;
  border-left: 2px solid;
  margin-left: 6px;
  margin-top: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: 5px;
}
._tooltip-right__traf-div:not(:first-child) {
  margin-top: 7px;
}
._tooltip-right__margin-bot {
  margin-bottom: 7px;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/ChartKit/modules/graph/tooltip/tooltip.scss"],"names":[],"mappings":"AAmBI;EACI,WAAA;EACA,YAAA;AAlBR;AAsBQ;EACI,0DAAA;AApBZ;AAyBQ;EACI,0DAAA;AAvBZ;AA8BQ;EACI,0DAAA;AA5BZ;AAiCQ;EACI,0DAAA;AA/BZ;;AAsCA;EACI,kBAAA;EACA,wCAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,4CAAA;AAnCJ;AAqCI;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AAnCR;AAqCQ;EACI,mBAAA;AAnCZ;AAsCQ;EACI,wBAAA;AApCZ;AA2CI;EACI;IACI,sDAAA;EAzCV;AACF;AA4CI;EACI,WAAA;AA1CR;AA4CQ;EACI,sBAAA;AA1CZ;AA6CQ;EACI,iBAAA;AA3CZ;AA+CI;EACI,WAAA;AA7CR;AA+CQ;EACI,SAAA;AA7CZ;AA+CY;EACI,UAAA;AA7ChB;AAiDQ;EACI,WAAA;AA/CZ;AAmDI;EACI,WAAA;AAjDR;AAmDQ;EACI,kBAtHC;AAqEb;AAoDQ;EACI,mBAzHS;AAuErB;AAqDQ;EACI,gBAAA;AAnDZ;AAqDY;EAEI,mBAAA;AApDhB;AAyDI;EACI,gBAAA;AAvDR;AA2DQ;EACI,mBA5IS;AAmFrB;AA6DI;EACI,mBAlJK;AAuFb;AA6DQ;EACI,YAAA;AA3DZ;AA+DI;EACI,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AA7DR;AA+DQ;EACI,qBAAA;AA7DZ;AA+DY;EACI,cAAA;AA7DhB;AAmEQ;EACI,iBAAA;EACA,WAAA;AAjEZ;AAmEY;EACI,cAAA;EACA,WAAA;AAjEhB;AAoEY;EACI,cAAA;EACA,WAAA;AAlEhB;AAoEgB;EACI,gBAAA;EACA,mBAAA;EACA,oDAAA;AAlEpB;AAsEY;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;AApEhB;AAsEgB;EACI,WAAA;EACA,cAAA;AApEpB;AAuEgB;EACI,kBAAA;AArEpB;AAuEoB;EACI,wDAAA;AArExB;AA0EoB;EACI,wDAAA;AAxExB;AA2EoB;EACI,gBAAA;EACA,mBAAA;AAzExB;AA6EgB;EACI,gBAAA;EACA,mBAAA;AA3EpB;AA8EgB;EA3NZ,0DAHkB;EAIlB,kBAAA;AAgJJ;AAiFY;EACI,qBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AA/EhB;AAmFQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAjFZ;AAoFQ;EACI,YAAA;AAlFZ;AAqFQ;EAvPJ,0DAHkB;EAIlB,kBAAA;EAyPQ,kBA9PO;EA+PP,mBAAA;AAnFZ;AAsFQ;EA9PJ,0DAHkB;EAIlB,kBAAA;EAgQQ,iBAAA;EACA,kBAAA;EACA,mBAAA;AApFZ;AAwFY;EACI,kBAAA;AAtFhB;AAyFY;EACI,SAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AAvFhB;AA2FQ;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAzFZ;AA4FQ;EACI,WAAA;AA1FZ;AA6FQ;EArSJ,0DAHkB;EAIlB,kBAAA;EAuSQ,mBAAA;EACA,kBA7SO;AAkNnB;AA6FY;EACI,kCAAA;EAAA,0BAAA;AA3FhB;AA+FQ;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AA7FZ;AA+FY;EACI,kCAAA;EAAA,0BAAA;AA7FhB;AAiGQ;EACI,sBAAA;EACA,mDAAA;EACA,eAAA;EACA,iDAAA;AA/FZ;AAiGY;EAnUR,0DAHkB;EAIlB,kBAAA;AAqOJ;AAiGY;EACI,kBAAA;EACA,gBAAA;AA/FhB;AAkGY;EACI,mBAnVK;EAoVL,iBAAA;AAhGhB;AAsGQ;EACI,mBAAA;AApGZ;AAyGQ;EACI,mBAAA;EACA,YAAA;EACA,kDAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAvGZ;AA2GY;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAzGhB;AA4GY;EACI,eAAA;AA1GhB;AA6GY;EACI,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;AA3GhB;AA+GQ;EACI,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,sBAAA;AA7GZ;AA+GY;EACI,oCAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AA7GhB;AAgHY;EACI,eAAA;AA9GhB;AAkHQ;EACI,kBAAA;AAhHZ","sourcesContent":[".chartkit-highcharts-tooltip-container_type_timeline {\n  width: 100%;\n  height: 100%;\n}\n.chartkit-highcharts-tooltip-container._tooltip-with-scroll ._tooltip-header td:last-child {\n  padding-right: calc(18px + var(--g-scrollbar-width, 15px));\n}\n.chartkit-highcharts-tooltip-container._tooltip-with-scroll ._tooltip-footer td:last-child {\n  padding-right: calc(18px + var(--g-scrollbar-width, 15px));\n}\n.chartkit-highcharts-tooltip-container._tooltip-with-scroll-in-safari ._tooltip-row td:last-child {\n  padding-right: calc(18px + var(--g-scrollbar-width, 15px));\n}\n.chartkit-highcharts-tooltip-container._tooltip-with-scroll-in-safari ._tooltip-rows__summ-tr td:last-child {\n  padding-right: calc(18px + var(--g-scrollbar-width, 15px));\n}\n\n._tooltip {\n  border-radius: 5px;\n  background: var(--highcharts-tooltip-bg);\n  color: var(--highcharts-tooltip-text);\n  font-size: 12px;\n  overflow: hidden;\n  box-sizing: border-box;\n  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.15);\n}\n._tooltip_split-tooltip {\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  padding-bottom: 12px;\n}\n._tooltip_split-tooltip table {\n  table-layout: fixed;\n}\n._tooltip_split-tooltip ._tooltip-rows__table tbody {\n  display: table-row-group;\n}\n@supports (padding: max(0px)) {\n  ._tooltip_split-tooltip {\n    padding-bottom: max(12px, env(safe-area-inset-bottom));\n  }\n}\n._tooltip table {\n  width: 100%;\n}\n._tooltip table td {\n  box-sizing: border-box;\n}\n._tooltip table td:last-child {\n  text-align: right;\n}\n._tooltip-fake-row {\n  height: 5px;\n}\n._tooltip-fake-row-heightless {\n  height: 0;\n}\n._tooltip-fake-row-heightless td {\n  padding: 0;\n}\n._tooltip-fake-row td:first-child {\n  width: 28px;\n}\n._tooltip-row {\n  width: 100%;\n}\n._tooltip-row td:first-child {\n  padding-left: 14px;\n}\n._tooltip-row td:last-child {\n  padding-right: 18px;\n}\n._tooltip-row td {\n  padding: 2px 4px;\n}\n._tooltip-row td._tooltip-rows__value-td, ._tooltip-row td._tooltip-rows__diff-td {\n  padding-bottom: 1px;\n}\n._tooltip-selected-row {\n  font-weight: 600;\n}\n._tooltip-comment-row td:last-child {\n  padding-right: 18px;\n}\n._tooltip-right__td {\n  padding-right: 14px;\n}\n._tooltip-right__td_with-split-tooltip {\n  border: none;\n}\n._tooltip-date {\n  padding: 10px 14px 4px;\n  max-width: 450px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: bold;\n}\n._tooltip-date-dayofweek {\n  display: inline-block;\n}\n._tooltip-date-dayofweek_weekend {\n  color: #ff0000;\n}\n._tooltip-rows__table {\n  border-spacing: 0;\n  width: 10px;\n}\n._tooltip-rows__table-footer {\n  display: table;\n  width: 100%;\n}\n._tooltip-rows__table thead {\n  display: table;\n  width: 100%;\n}\n._tooltip-rows__table thead._tooltip-header tr:not(._tooltip-fake-row):first-child td {\n  padding-top: 6px;\n  padding-bottom: 6px;\n  border-bottom: 1px solid var(--highcharts-grid-line);\n}\n._tooltip-rows__table tbody {\n  display: block;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n._tooltip-rows__table tbody._tooltip-footer {\n  width: 100%;\n  display: table;\n}\n._tooltip-rows__table tbody._tooltip-list {\n  overflow-x: hidden;\n}\n._tooltip-rows__table tbody._tooltip-list ._tooltip-row-dark-bg {\n  background-color: var(--highcharts-tooltip-alternate-bg);\n}\n._tooltip-rows__table tbody ._hidden-rows-sum._hidden-rows-sum-dark-bg {\n  background-color: var(--highcharts-tooltip-alternate-bg);\n}\n._tooltip-rows__table tbody ._hidden-rows-sum td {\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n._tooltip-rows__table tbody td._hidden-rows-number {\n  text-align: left;\n  padding-right: 20px;\n}\n._tooltip-rows__table tbody td._hidden-rows-value {\n  font-family: \"Consolas\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  word-spacing: -3px;\n}\n._tooltip-rows__bubble-div {\n  display: inline-block;\n  width: 12px;\n  height: 6px;\n  margin-left: 1px;\n  margin-bottom: 1px;\n  border-radius: 1px;\n}\n._tooltip-rows__shape-div {\n  width: 38px;\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n._tooltip-rows__shape-td {\n  height: 20px;\n}\n._tooltip-rows__percent-td {\n  font-family: \"Consolas\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  word-spacing: -3px;\n  padding-left: 12px;\n  white-space: nowrap;\n}\n._tooltip-rows__diff-td {\n  font-family: \"Consolas\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  word-spacing: -3px;\n  padding-left: 3px;\n  padding-right: 3px;\n  white-space: nowrap;\n}\n._tooltip-rows__comment-left-td {\n  position: relative;\n}\n._tooltip-rows__comment-left-div {\n  left: 2px;\n  position: absolute;\n  top: -7px;\n  bottom: 6px;\n  width: 10px;\n}\n._tooltip-rows__comment-div {\n  position: relative;\n  padding-left: 14px;\n  text-align: left;\n  font-size: 10px;\n  width: auto;\n  white-space: normal;\n  letter-spacing: 0.2px;\n  font-weight: normal;\n  line-height: 1.3;\n  color: #aaaaaa;\n}\n._tooltip-rows__bubble-td {\n  width: 28px;\n}\n._tooltip-rows__value-td {\n  font-family: \"Consolas\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  word-spacing: -3px;\n  white-space: nowrap;\n  padding-left: 12px;\n}\n._tooltip-rows__value-td_selected {\n  text-decoration: underline;\n}\n._tooltip-rows__name-td {\n  text-align: left;\n  white-space: nowrap;\n  padding-left: 10px;\n  max-width: 400px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n._tooltip-rows__name-td_selected {\n  text-decoration: underline;\n}\n._tooltip-rows__summ-td {\n  padding: 6px 0 6px 3px;\n  color: var(--highcharts-tooltip-text-complementary);\n  font-size: 12px;\n  border-top: 1px solid var(--highcharts-grid-line);\n}\n._tooltip-rows__summ-td-value {\n  font-family: \"Consolas\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  word-spacing: -3px;\n}\n._tooltip-rows__summ-td:first-child {\n  padding-left: 15px;\n  text-align: left;\n}\n._tooltip-rows__summ-td:last-child {\n  padding-right: 18px;\n  text-align: right;\n}\n._tooltip-left__td {\n  vertical-align: top;\n}\n._tooltip-right__td {\n  vertical-align: top;\n  opacity: 0.9;\n  border-left: 1px solid var(--highcharts-grid-line);\n  white-space: normal;\n  font-size: 8pt;\n  position: relative;\n  min-width: 120px;\n  max-width: 150px;\n  padding-left: 10px;\n}\n._tooltip-right__holiday-div {\n  padding-bottom: 5px;\n  display: flex;\n  align-items: center;\n  text-align: left;\n}\n._tooltip-right__holiday-emoji {\n  font-size: 20px;\n}\n._tooltip-right__holiday-region {\n  color: #ffffff;\n  letter-spacing: 1px;\n  display: inline-block;\n  padding-left: 5px;\n}\n._tooltip-right__traf-div {\n  text-align: left;\n  border-top: 3px solid;\n  padding-top: 3px;\n  font-size: 10px;\n  line-height: 1.3;\n  white-space: pre-line;\n  padding-bottom: 10px;\n  margin-top: 9px;\n  word-break: break-word;\n}\n._tooltip-right__traf-div_for-split-tooltip {\n  color: var(--g-color-text-secondary);\n  padding-left: 8px;\n  border-top: none;\n  border-left: 2px solid;\n  margin-left: 6px;\n  margin-top: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-bottom: 5px;\n}\n._tooltip-right__traf-div:not(:first-child) {\n  margin-top: 7px;\n}\n._tooltip-right__margin-bot {\n  margin-bottom: 7px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
